export const ENTRY_REASONS = [
  "Other",
  "Original entry into a United States school",
  "Original entry into a United States school from a foreign country with an interruption in schooling",
  "Original entry into a United States school from a foreign country with no interruption in schooling",
  "Re-entry after a voluntary withdrawal",
  "Re-entry after an involuntary withdrawal",
  "Re-entry from the same school with no interruption of schooling",
  "Transfer from a charter school",
  "Transfer from a private, non - religiously - affiliated school in a different local education agency in the same state",
  "Transfer from a private, non - religiously - affiliated school in a different state",
  "Transfer from a private, non - religiously - affiliated school in the same local education agency",
  "Transfer from a private, religiously - affiliated school in a different local education agency in the same state",
  "Transfer from a private, religiously - affiliated school in a different state",
  "Transfer from a private, religiously - affiliated school in the same local education agency",
  "Transfer from a public school in a different local education agency in the same state",
  "Transfer from a public school in a different state",
  "Transfer from a public school in the same local education agency",
  "Transfer from a school outside of the country",
  "Transfer from an institution",
  "Transfer from home schooling"
];

export const DWELLING_TYPES = [
  "Family residence",
  "Foster home",
  "Group home/halfway house",
  "No home",
  "Other dormitory",
  "Residental school/dormitory",
  "Rooming house",
  "Transient shelter",
  "Boarding house",
  "Cooperative house",
  "Crisis shelter",
  "Disaster shelter",
  "Institution",
  "Other"
];
